import React, { createContext } from 'react'
import { BaseContextState, BaseContextProvider } from '../BaseContext'
import IMappingStatsPending from '../../interfaces/IMappingStatsPending'
import { mappingStatsPendingCount } from '../../services/api'

interface MappingStatsContextState extends BaseContextState {
  mappingPending: IMappingStatsPending | null
}

interface MappingStatsContextData extends MappingStatsContextState {
  resetErrors: Function,

  requestMappingStatsPending: () => void,
}

// Create context
const { Provider, Consumer } = createContext({} as MappingStatsContextData)

// Export consumer
export const MappingStatsConsumer = Consumer

export class MappingStatsProvider extends BaseContextProvider {
  state: MappingStatsContextState = {
    mappingPending: null
  }

  /**
   * Make api request for mapping stats pending
   *
   */
  requestMappingStatsPending = () => {
    this.setState({
      fetching: true,
      error: null
    }, async () => {
      const response = await mappingStatsPendingCount()

      // Process our response
      this.processResponse(response, { 
        mappings: [
          { origin: 'mapping_pending', destination: 'mappingPending' }
        ]
      })
    })
  }

  render() {
    return (
      <Provider
        value={{
          // States
          ...this.state,

          // Dispatches
          resetErrors: this.resetErrors,
          requestMappingStatsPending: this.requestMappingStatsPending,
        }}
      >
        {this.props.children}
      </Provider>
    )
  }
}
